(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('site', {
            abstract: true,
            template: '<ui-view/>',
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }

        }).state('main', {
            parent: 'site',
            data: {
                authorities: [],
                evaluateAuthorities: ''
            },
            templateUrl: 'app/layouts/content.html',
            controller: 'MainController',
            controllerAs: 'vm'
        }).state('app', {
            parent: 'main',
            views: {
                'navbar@main': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'aside@main': {
                    templateUrl: 'app/layouts/aside/aside.html',
                    controller: 'AsideController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
